import { tryLoadLightDOMStyles } from '@/components/webcomponents/Global/loadDependency'
import { getTemplateFormControlMessagingStyles } from './FormControlMessaging.styles'

const t = document.createElement('template')
t.innerHTML = `
  <div>
    <slot name="control-info"></slot>
    <slot name="control-error"></slot>
    <slot name="label"></slot>
    <slot name="label-info"></slot>
  </div>
`
const TemplateFormControlMessaging = t

class FormControlMessaging extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateFormControlMessagingStyles().content.cloneNode(true))
    shadow.appendChild(TemplateFormControlMessaging.content.cloneNode(true))

    tryLoadLightDOMStyles('FormControlMessaging.css')
  }

  connectedCallback() {
    document.AscendAwesome?.LogManager?.logDebug('FormControlMessaging connectedCallback: ', this)
  }

  static get observedAttributes() {
    return ['info', 'error']
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === 'info') {
      const controlInfo = this.shadowRoot?.querySelector('slot[name="control-info"]')
      if (controlInfo) {
        controlInfo.innerHTML = newValue
      }
    } else if (name === 'error') {
      const controlError = this.shadowRoot?.querySelector('slot[name="control-error"]')
      if (controlError) {
        controlError.innerHTML = `<span class="error-text">${newValue}</span>`
      }
    }
  }
}

if (!customElements.get('ts-form-control-messaging')) {
  customElements.define('ts-form-control-messaging', FormControlMessaging)
}
export { FormControlMessaging }
